import React from 'react'
import { ReportExecutiveCard } from '../reportExecutiveCard/ReportExecutiveCard'

export const ExecutiveSummaryCards = ({data}) => {
  return (
    <div className="executive-summary-cards-container mt-4 flex gap-x-7">
        <ReportExecutiveCard number={data.total_schools} text={"Number of schools"}/>
        <ReportExecutiveCard number={data.total_smart_class} text={"Number of smart classes"}/>
        <ReportExecutiveCard number={Math.ceil(data.total_video_usage)} text={"Learner Engagement (Time spent in hours)"}/>
        <ReportExecutiveCard number={Math.ceil(data.total_exercise_usage)} text={"Lesson Assessment Practice(In hours)"}/>
        <ReportExecutiveCard number={data.total_teachers} text={"Number of teachers trained by Aveti Learning"}/>
    </div>
  )
}
